import { CheckIcon, CloseIcon } from '@cmg/design-system';

type BooleanIconProps = Readonly<{ value: boolean }>;

export function BooleanIcon({ value }: BooleanIconProps) {
  if (value) {
    return <CheckIcon fontSize="small" color="success" aria-label="Yes" />;
  }

  return <CloseIcon fontSize="small" color="disabled" aria-label="No" />;
}
